module.exports = __webpack_public_path__ + "static/img/gnmk_8@2x.b4aeb8f5.png";